<template>
    <div class="plan">

        <div class="plan-header">

            <h3 class="is-small">{{ data.title }}</h3>

            <div class="image-container">
                <img :src="getIcon" alt="people icon">
            </div>

        </div>

        <div class="plan-content">

            <p class="text is-green is-extra-small plan-price">${{ data.price }}/month</p>

            <ul class="plan-features">

                <li v-for="feature in data.features" :key="feature.id">{{ feature }}</li>

            </ul>

            <button class="btn is-bordered subscribe-button" @click="scrollToBeta">
                <div>
                    <span>Subscribe</span>
                </div>
            </button>

        </div>

    </div>
</template>

<script>
    export default {
        name: 'Plan',
        props: {
            data: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            index: {
                type: Number,
                default: 0
            }
        },
        computed: {
            getIcon() {
                return require('../assets/images/icons/' + this.data.icon)
            }
        },
        methods: {
            scrollToBeta() {

                this.$parallax.scrollTo('getbeta')
                this.$emit('subscribe', this.index)

            }
        }
    }
</script>